import { render, staticRenderFns } from "./ScorllList.vue?vue&type=template&id=86462326&scoped=true&"
import script from "./ScorllList.vue?vue&type=script&lang=ts&"
export * from "./ScorllList.vue?vue&type=script&lang=ts&"
import style0 from "./ScorllList.vue?vue&type=style&index=0&id=86462326&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86462326",
  null
  
)

export default component.exports